import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBible } from '@fortawesome/free-solid-svg-icons';
import { faSpotify, faYoutube } from '@fortawesome/free-brands-svg-icons';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import { PodcastsRounded,
  RadioRounded,
  SecurityRounded,
  DescriptionRounded,
} from '@mui/icons-material';

import { stations } from '../../data/stations';

const PlayerCard = ({ station, isPlaying, setIsPlaying }) => (
  <Card sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    p: 2, 
    borderRadius: 2, 
    boxShadow: 3, 
    backgroundColor: isPlaying ? '#3555dd' : 'rgba(0, 0, 0, 0.3)', 
    color: 'white' 
  }}>
    <Avatar sx={{
      bgcolor: 'rgba(0, 0, 0, 0.3)',
      mr: 2,
      width: 56,
      height: 56
    }}>
      <RadioRounded />
    </Avatar>
    <CardContent sx={{ flex: 1, p: 0, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Typography variant="subtitle1" noWrap>
        Embajadores Stereo
      </Typography>
      <Typography variant="body2" color="white" sx={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
        {isPlaying ? 'Reproduciendo' : 'Detenido'}
      </Typography>
    </CardContent>
    {/* <IconButton onClick={() => setIsPlaying(!isPlaying)}>
      {isPlaying ? <StopRounded /> : <PlayArrowRounded />}
    </IconButton> */}
  </Card>
);

export default function TemporaryDrawer({ open, toggleDrawer, station, setStation, isLogged, isPlaying, setIsPlaying }) {
  const navigate = useNavigate();
/*
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);
*/
  const audioList = [
    {
      name: 'Predicas',
      icon: <FontAwesomeIcon icon={faSpotify} size='lg' />,
      action: () => window.open('https://creators.spotify.com/pod/show/embajadoresdelgranrey')
    },
    {
      name: 'Un momento con Dios',
      icon: <FontAwesomeIcon icon={faYoutube} size='lg' />,
      action: () => window.open('https://www.youtube.com/playlist?list=PL4oo6KtmAKPlZaEq7BD6N-aBPzSOTeqjK')
    },
    {
      name: 'Podcasts',
      icon: <PodcastsRounded />,
    },
    {
      name: 'Versiculo del día',
      icon: <FontAwesomeIcon icon={faBible} size='lg' />,
      action: () => navigate('/versiculodeldia')
    },
    // {
    //   name: 'Donar',
    //   icon: <FontAwesomeIcon icon={faHandHoldingDollar} />
    // }
  ];

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation">
      {/* Header */}
      <Box sx={{ px: 2, my: 3 }}>
        <PlayerCard station={station} isPlaying={isPlaying} setIsPlaying={setIsPlaying} />
      </Box>

      {/* Menu */}
      <Typography
        variant="overline"
        sx={{
          px: 2,
          display: "block",
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        Estaciones de radio
      </Typography>

      <List>
        {stations.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              disabled={!item.status}
              onClick={() => {
                if (station !== item.link) {
                  setStation(item.link);
                  console.log('Station: ', item.link);
                }
                navigate('/');
                toggleDrawer(false)();
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <RadioRounded />
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Typography
        variant="overline"
        sx={{
          px: 2,
          display: "block",
          color: "text.secondary",
          fontWeight: 500,
        }}
      >
        Más contenido
      </Typography>
      <List>
        {audioList.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => {
                if (item.action) item.action();
                toggleDrawer(false)();
              }}
              disabled={!item.action}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {/* <ListItem disablePadding>
          <ListItemButton onClick={() => navigate('/donate')} disabled>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <VolunteerActivismRounded />
            </ListItemIcon>
            <ListItemText primary='Donar' />
          </ListItemButton>
        </ListItem> */}
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/privacy');
              toggleDrawer(false)();
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <SecurityRounded />
            </ListItemIcon>
            <ListItemText primary='Privacidad y tratamiento de datos' />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              navigate('/terms');
              toggleDrawer(false)();
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <DescriptionRounded />
            </ListItemIcon>
            <ListItemText primary='Términos y condiciones' />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}